import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { WebhookEvent } from 'dashboard/models/webhook-event';
import { setWebhookEvent } from 'dashboard/redux/slices/webhook-event';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export const loadWebhookEvent = (id: string) => {
  return async (dispatch: Dispatch) => {
    const webhookResponse = await SessionClientDashboard.getResource<WebhookEvent>(
      ApiEndpoint.WebhookEvent,
      id,
    );

    const webhook = webhookResponse.data;

    dispatch(setWebhookEvent(webhook));
  };
};

export const rerunWebhookEvent = (id: string, meta: { 'password-confirmation': string }) => {
  return async () => {
    const rerunWebhookEventResponse = await SessionClientDashboard.postResourceAction<WebhookEvent>(
      {
        type: ApiModel.WebhookEvent as const,
        id: id,
      },
      'rerun',
      {
        meta: {
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return rerunWebhookEventResponse;
  };
};
